export const baseURL = "https://swo.drfit.site/";
export const key = "133e1f54e11f90ef6d7a";
export const projectName = "Vola Party";
